import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListViewItem } from 'app/components/common/listViewItem';

@Component({
    selector: 'psm-dropdown',
    templateUrl: 'dropdown.component.html'
})

export class DropDownComponent {

    @Output()
    public valueChange = new EventEmitter<any>();

    private static _inc = 0;

    @Input()
    public value: any;

    @Input()
    public name?: string = `dropDown_${DropDownComponent._inc++}`;

    @Input()
    public listItems?: ListViewItem[];
}


// WEBPACK FOOTER //
// ./src/app/components/common/dropdown/dropdown.component.ts